import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import AppRouter from './AppRouter.tsx';
import { initAnalytics } from '#/utils/analytics';
import { parseUrlParams, saveCampaignContext } from '#/utils/campaignContext';

initAnalytics();
saveCampaignContext(parseUrlParams(window.location.search));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppRouter />
  </StrictMode>
);
